import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import { FeedbacksBoard } from './FeedbacksBoard/FeedbacksBoard';
import { FeedbacksPageInfo } from './FeedbacksPageInfo/FeedbacksPageInfo';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { XlsBtn } from '~/ui';
import { ReportDrawer } from '~/components/ReportDrawer/ReportDrawer';
import { FeedbacksReportExtra } from './FeedbacksReportExtra/FeedbacksReportExtra';
import { downloadReportWithFields } from '~/utils/downloadReportFile';
import { Dayjs } from 'dayjs';

interface IAccommodation {
  id: number;
  name: string;
}

const REPORT_TYPE = 'feedback_accommodation_date_export';

const Feedbacks = () => {
  const { t } = useTranslation();
  const [statusFilter, setStatusFilter] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [accommodations, setAccommodations] = useState<IAccommodation[]>([]);
  const [isAllAccommodationChecked, setIsAllAccommodationChecked] =
    useState(false);

  const currentFilters = {
    start_date: startDate?.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    end_date: endDate?.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    ...(isAllAccommodationChecked
      ? { accommodation_all: 1 }
      : { accommodation_ids: accommodations.map((a) => a.id) }),
  };

  const handleExport = async (fields: string[]) => {
    await downloadReportWithFields(
      'analytics-feedback-accommodation-date',
      'analytics-accommodation-feedback',
      { ...currentFilters, fields }
    );
  };

  const handlePresetExport = async (presetId: number) => {
    await downloadReportWithFields(
      'analytics-feedback-accommodation-date',
      'analytics-accommodation-feedback',
      { preset_id: presetId }
    );
  };

  return (
    <Page
      heading={
        <Heading
          text={t('feedback')}
          actions={
            <XlsBtn
              onClick={() => setDrawerOpen(true)}
              xlsBtnText={t('feedback_analytics')}
            />
          }
        />
      }
    >
      <FeedbacksPageInfo statusFilter={statusFilter} setStatusFilter={setStatusFilter} />
      <FeedbacksBoard statusFilter={statusFilter} />
      <ReportDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        reportType={REPORT_TYPE}
        onExport={handleExport}
        onPresetExport={handlePresetExport}
        extraParams={currentFilters}
        isExportDisabled={
          (!accommodations.length && !isAllAccommodationChecked) ||
          !startDate ||
          !endDate
        }
        title={t('feedback_analytics')}
        extraContent={
          <FeedbacksReportExtra
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
            accommodations={accommodations}
            onAccommodationsChange={setAccommodations}
            isAllAccommodationChecked={isAllAccommodationChecked}
            onAllAccommodationChange={setIsAllAccommodationChecked}
          />
        }
      />
    </Page>
  );
};

export default Feedbacks;
